export const bandbearsNFTs = [

  {
    id: 'bandbear-179',
    name: 'Band Bears #179',
    image: 'https://ipfs.io/ipfs/QmQ2x4h3f8iedXPfFnZ2gdGo6qxieVvkBeLrnuHpoRVh9v',
    price: '18.5 ETH'
  },
  {
    id: 'bandbear-677',
    name: 'Band Bears #677',
    image: 'https://ipfs.io/ipfs/QmYzCRdTSecZUg1L5tNNtGzdtD2TikYaV9tiqNJe1k9h3Q',
    price: '22.3 ETH'
  },
  {
    id: 'bandbear-833',
    name: 'Band Bears #833',
    image: 'https://ipfs.io/ipfs/QmafG1mThyYsSGqxH5RTKu3jkG4bCK46G5mKCrEpf3Num8',
    price: '15.7 ETH'
  },
  {
    id: 'bandbear-456',
    name: 'Band Bears #456',
    image: 'https://ipfs.io/ipfs/QmT7wMq5uoEe2k6UukWbmmFiL2NAkQLzc4iQcro6MXgvTT',
    price: '24.2 ETH'
  },
  {
    id: 'bandbear-655',
    name: 'Band Bears #655',
    image: 'https://ipfs.io/ipfs/QmWepCs8emxDtiUx7sdEdEnFU4qfJbBNvcSdq8QWSmy8k1',
    price: '19.8 ETH'
  },
  {
    id: 'bandbear-157',
    name: 'Band Bears #157',
    image: 'https://ipfs.io/ipfs/QmSh1xchJw9TDFuKNxvSZypPSXm3pFyzTs4czttgoky6kR',
    price: '13.4 ETH'
  },
  {
    id: 'bandbear-954',
    name: 'Band Bears #954',
    image: 'https://ipfs.io/ipfs/QmZminP3gjysAgHU3XSAwC1oGnNtygXH5PwWc5UKceJr6e',
    price: '21.6 ETH'
  },
  {
    id: 'bandbear-952',
    name: 'Band Bears #952',
    image: 'https://ipfs.io/ipfs/QmUrLgtSgjDEwdU21y5VVs7duDCKhvxm3f8VP4xKyNxcGV',
    price: '16.9 ETH'
  },
  {
    id: 'bandbear-454',
    name: 'Band Bears #454',
    image: 'https://ipfs.io/ipfs/QmQnFPNJGXYXsH6HQxxnqxFuccG6fx9YjTNVRt9tdVCg3V',
    price: '23.5 ETH'
  },
  {
    id: 'bandbear-963',
    name: 'Band Bears #963',
    image: 'https://ipfs.io/ipfs/QmQPhH5gBaGTeHHoituUpGcpcW3LWY79f3haN8DP6jP5Bs',
    price: '17.8 ETH'
  },
  {
    id: 'bandbear-770',
    name: 'Band Bears #770',
    image: 'https://ipfs.io/ipfs/QmZ88JzsfBfzwxLAtBezUJCVbu1XUr6HdMHDD46TKRRg48',
    price: '20.4 ETH'
  },
  {
    id: 'bandbear-554',
    name: 'Band Bears #554',
    image: 'https://ipfs.io/ipfs/QmZvhXdkfPjvyvd3ihzq9N9hcesk4U5NcesC4e2Lcwd7i4',
    price: '14.2 ETH'
  },
  {
    id: 'bandbear-272',
    name: 'Band Bears #272',
    image: 'https://ipfs.io/ipfs/QmRDB2JzqHGrCZHMxeN1kMq5QnVSoPNVxnytctV69t6Fz8',
    price: '25.0 ETH'
  },
  {
    id: 'bandbear-146',
    name: 'Band Bears #146',
    image: 'https://ipfs.io/ipfs/QmTAwPpeW5tbuvHaSsX7rZuK5JstyTRGBEFG3PY3HNFNhU',
    price: '11.5 ETH'
  },
  {
    id: 'bandbear-644',
    name: 'Band Bears #644',
    image: 'https://ipfs.io/ipfs/QmWro8YQ2eKWvBjZegQc5jPMsYfcyn42tgqWYc9iHmvahe',
    price: '19.1 ETH'
  }

];